import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { bannerInfo, sloganInfo, productsInfo, eventInfo } from "../VipJumbotronFunc";

const VipJumbotronV3 = ({ game_id, products, gift, area, newebpayBulletin }) => {
  const paymentMethod = area === "tw" ? "信用卡、ATM轉帳、WebATM。":"信用卡、銀聯卡。";

  const special_note =
    game_id === "g66naxx2tw" ? (
      <div className="small">
        <span role="img" aria-label="sparkling stars">
          ✨ ✨ ✨ ✨ 注意 ✨ ✨ ✨ ✨
        </span>
        <br />
        <br />
        電台方案付費方式更改為藍新金流，請依表單流程執行即可。<br />
        付費方式：{paymentMethod}<br />
        <br />
        <span role="img" aria-label="loudspeaker">
          📢
        </span>
        電台方案僅適用【台灣龍邑版】<br />
        用戶若使用【<strong className="text-danger">海外全球版</strong>】，<strong className="text-danger">無法購買</strong>。<br />
        判斷方式：【<strong className="text-danger">海外全球版</strong>】遊戲APP圖示右下角<strong className="text-danger">有</strong>網易Logo角標。<br />
        需請您重新下載安裝【台灣龍邑版】後，再繼續填表單。<br />
        判斷方式：【台灣龍邑版】遊戲APP圖示<strong className="text-danger">無</strong>網易Logo角標。<br />
        <br />
        <strong className="text-danger">
          <span role="img" aria-label="loudspeaker">
            📢
          </span>
          若您欲購買未滿3000元的品項，歡迎使用
          <a target="blank" href="https://www.lifeafterpay.com/">
            <img
              width="60"
              alt="MyCard logo"
              src="https://image.mycard520.com/globalmycard/images/mycard_logo.png"
            />
          </a>
          進行儲值喔!
          <br />
        </strong>
      </div>
    ) : game_id === "G112" ? (
      <Fragment>
        <h3 className="mt-2">首儲獎勵：</h3>
        <ul>
          <li>
            <span role="img" aria-label="box">
              🔹
            </span>
            NTD.10,000，可獲得 頂級底盤30個。
          </li>
          <li>
            <span role="img" aria-label="box">
              🔹
            </span>
            NTD.20,000，可獲得 頂級底盤80個。
          </li>
          <li>
            <span role="img" aria-label="box">
              🔹
            </span>
            NTD.30,000，可獲得 頂級底盤150個。
          </li>
          <li>
            <span role="img" aria-label="box">
              🔹
            </span>
            NTD.50,000，可獲得 頂級底盤250個。
          </li>
        </ul>
        ※首儲獎勵僅限第一次儲值該方案時獲得，每個方案可各領取一次。<br />
        <br />
        <br />
        <div className="small">
          <span role="img" aria-label="sparkling stars">
            ✨ ✨ ✨ ✨ 注意 ✨ ✨ ✨ ✨
          </span>
          <br />
          <br />
          本服務使用藍新金流，請依表單流程執行即可。<br />
          付費方式：{paymentMethod}<br />
          <br />
          <strong className="text-danger">
            <span role="img" aria-label="loudspeaker">
              📢
            </span>
            以上方案僅適用於【台港澳】版本。
            <br />
            <span role="img" aria-label="loudspeaker">
              📢
            </span>
            若您欲購買未滿10,000元的品項，歡迎使用
            <a target="blank" href="https://pay.longeplay.com.tw/racingmaster/topup">
              <img
                width="60"
                alt="MyCard logo"
                src="https://image.mycard520.com/globalmycard/images/mycard_logo.png"
              />
            </a>
            進行儲值喔!
            <br />
          </strong>
        </div>
      </Fragment>
    ) : game_id === "L33" ? (
      <div className="small">
        <span role="img" aria-label="sparkling stars">
          ✨ ✨ ✨ ✨ 注意 ✨ ✨ ✨ ✨
        </span>
        <br />
        <br />
        本服務使用藍新金流，請依表單流程執行即可。<br />
        付費方式：{paymentMethod}<br />
        <br />
        <strong className="text-danger">
          <span role="img" aria-label="loudspeaker">
            📢
          </span>
          以上方案僅適用於【台港澳】版本。
          <br />
          <span role="img" aria-label="loudspeaker">
            📢
          </span>
          若您欲購買未滿10000元的品項，歡迎使用
          <a target="blank" href="https://pay.longeplay.com.tw/allstar/topup">
            <img
              width="60"
              alt="MyCard logo"
              src="https://image.mycard520.com/globalmycard/images/mycard_logo.png"
            />
          </a>
          進行儲值喔!
          <br />
        </strong>
      </div>
    ) : game_id === "MA96" ? (
      <div className="small">
        本服務使用藍新金流，請依表單流程執行即可。<br />
        付費方式：{paymentMethod}<br />
        <br />
        <strong className="text-danger">
          <span role="img" aria-label="loudspeaker">
            📢
          </span>
          方案現僅適用【龍邑台港澳版本】。
          <br />
          <span role="img" aria-label="loudspeaker">
            📢
          </span>
          若您欲購買未滿5000元的品項，歡迎使用
          <a target="blank" href="https://www.neverafter-pay.tw/">
            <img
              width="60"
              alt="MyCard logo"
              src="https://image.mycard520.com/globalmycard/images/mycard_logo.png"
            />
          </a>
          進行儲值喔!
          <br />
        </strong>
      </div>
    ) : (
      <div className="small">
        本服務使用藍新金流，請依表單流程執行即可。<br />
        付費方式：{paymentMethod}<br />
        <br />
        <strong className="text-danger">
          <span role="img" aria-label="loudspeaker">
            📢
          </span>
          僅提供龍邑亞洲服角色購買。
          <br />
        </strong>
      </div>
    );

  
  const banner = bannerInfo(game_id);
  const slogan = sloganInfo(game_id);
  const event_alert = eventInfo(game_id, gift);
  const products_info = productsInfo(game_id, products);
  
  // ? 'NTD.3,000，信用點 6480 贈 1788，共可獲得 8268 信用點。'
  // : '儲值NTD.3,000，共可獲得7200回聲。';
  const contact_nickname1 = game_id === "g66naxx2tw" || game_id === "G115" ? "小夥伴" : game_id === "MA96" ? "小精靈" : "小管家";
  
  return (
    <Fragment>
      <div className="row">
        <div className="col-lg-3 mt-3"> </div>
        <div className="col-lg-6  col-sm-12  mt-3">{banner}</div>
        <div className="col-lg-3 mt-3"> </div>
      </div>
      {newebpayBulletin ? (
      <div className="row">
        <div className="col-lg-3 mt-3"> </div>
        <div className="col-lg-6  col-sm-12  mt-3">
        <div className="alert alert-danger" role="alert">
        <p
          dangerouslySetInnerHTML={{
            __html: newebpayBulletin.content
          }}
        />
        </div>
        </div>
      </div>
      ) : ""}
      <div className="row">
        <div className="col-lg-3 mt-3"> </div>
        <div className="col-lg-6  col-sm-12 mt-3">
          <div className="jumbotron jumbotron-fluid">
            <div className="container">
              {slogan}
              <hr className="my-4" />
              {event_alert}
              {products_info}
              {special_note}
              <p className="small">
                <strong className="text-danger">
                <span role="img" aria-label="loudspeaker">
                  📢
                </span>
                未滿18歲之購買者，將無法提供後續服務。
                  <br />
                <span role="img" aria-label="loudspeaker">
                  📢
                </span>
                交易完成後，無法進行退換貨服務。
                  <br />
                </strong>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

VipJumbotronV3.propTypes = { game_id: PropTypes.string.isRequired };

export default VipJumbotronV3;
